<template>
  <div id="app-index">
    <pub-head></pub-head>
    <pubs-nav></pubs-nav>

    <div class="details-box">
      <div class="details-top" v-if="bread1 || bread2">
        <h3 v-if="bread2">
          您的位置：{{bread1}} >{{bread2}}>
          <span>详情</span>
        </h3>
        <h3 v-else>
          您的位置：{{bread1}}>
          <span>详情</span>
        </h3>
      </div>
      <div style="display:flex">
        <div class="details-content">
          <h2>{{newsData.news_title}}</h2>
          <el-alert
            title="提示：该页面为新闻预览页面~"
            style="margin:50px 0px"
            type="info"
            close-text="知道了"
            v-if="$route.query.ifview"
          ></el-alert>
          <div class="time-box">
            <span>点击：{{newsData.news_view}}次</span>
            <span>时间：{{newsData.custom_time}}</span>
          </div>
          <div class="intd-box" v-if="newsData.description && newsData.description != ''">
            <p>{{newsData.description}}</p>
          </div>
          <div v-if="newsData.video && newsData.video != ''">
            <div v-html="newsData.video" class="video-box"></div>
          </div>
          <div class="content-box" v-html="newsData.content"></div>
        </div>
        <div style="width:25%;" class="newlist">
          <details-news :newsList="newsList"></details-news>
        </div>
      </div>
    </div>

    <pub-foot></pub-foot>
  </div>
</template>
<script>
import animate from "animate.css";
import pubHead from "../Public/head";
import pubsNav from "../Public/nav";
import pubFoot from "../Public/foot";
import detailsNews from "./details_news";

export default {
  components: {
    pubHead,
    pubsNav,
    pubFoot,
    detailsNews
  },
  data() {
    return {
      newsData: {},
      bread1: null,
      newsList: [], //推荐新闻列表
      bread2: null,
      type: ""
    };
  },
  methods: {
    //获取侧边推荐新闻
    getNewslist() {
      this.$db.post(this.$db.config.getRecommendNewsList, {}).then(res => {
        if (res.code == 200) {
          this.newsList = res.data;
        }
      });
    },

    getNewDetail(id) {
      let data = {};
      data.id = id;
      if (this.$route.query.ifview) {
        data.ifview = this.$route.query.ifview;
      }
      this.$db.post(this.$db.config.getNewsDetailUrl, data).then(res => {
        if (res.code == 200) {
          this.newsData = res.data;
        }
      });
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.getNewDetail(val.query.id);
      },
      // 深度监听
      deep: true
    }
  },
  created() {
    this.getNewslist();

    this.type = this.$route.query.type;

    this.getNewDetail(this.$route.query.id);

    ///根据一级id获取二级导航
    if (this.$route.query.cid) {
      this.$db
        .post(this.$db.config.getChildByChidUrl, { id: this.$route.query.cid })
        .then(res => {
          res.data.forEach((item, index) => {
            if (item.id == this.$route.query.cid) {
              this.bread1 = item.channel_title;
            }
            if (item.id == this.$route.query.tabid) {
              this.bread2 = item.channel_title;
            }
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
#app-index {
  background-color: #eee;
  width: 100%;
  min-width: 1050px;
}

.details-box {
  width: 1300px;
  margin: 0 auto;
  .details-top {
    > h3 {
      font-size: 14px;
      color: #999;
      text-align: right;
      font-weight: normal;
      padding: 28px 0 17px;
      > span {
        color: #333333;
      }
    }
  }
  .details-content {
    margin-top: 15px;
    width: 70%;
    margin-right: 10px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    padding: 0 20px;
    border-top: 3px solid #c30d23;
    border-bottom: none;
    margin-bottom: 30px;
    > h2 {
      font-size: 36px;
      text-align: center;
      color: #333333;
      margin-bottom: 30px;
      margin-top: 45px;
    }
    .time-box {
      margin-bottom: 20px;
      text-align: center;
      > span {
        font-size: 12px;
        color: #999999;
        padding-right: 28px;
        &:last-child {
          padding-right: 0;
        }
      }
    }
    .intd-box {
      width: 100%;
      background-color: #f3f3f3;
      > p {
        font-size: 14px;
        line-height: 30px;
        color: #333333;
        padding: 15px 35px;
        text-align: left;
      }
    }

    .video-box {
      width: 80%;
      height: 400px;
      margin: 20px auto;
    }
    .video-box /deep/ iframe {
      width: 100%;
      height: 100%;
    }
    .content-box {
      margin-top: 50px;
      margin-bottom: 90px;
      > p {
        font-size: 16px;
        line-height: 36px;
        color: #333333;
        margin-bottom: 46px;
        text-indent: 2em;
      }
    }

    .content-box /deep/ img {
      max-width: 96% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News/public_news_details.vue